<template>
  <div
    :class="[
      'd-flex flex-column rounded-lg fill-background',
      {
        'border-gray': !opened || !borderHighlight,
        'border-blue': opened && borderHighlight,
        'px-6 py-4': !small,
        'px-3 py-2': small,
        // 'disabled-filter': disabled,
      },
    ]"
  >
    <div class="d-flex flex-row justify-space-between align-center gap-4" role="button" @click="toggle">
      <span v-if="!!title" :class="['font-weight-medium', { 'font-size-14': small }]">{{ title }}</span>
      <slot v-else name="title" />
      <v-icon v-if="!!expandIcon && !!collapseIcon && !hideArrow"> {{ opened ? collapseIcon : expandIcon }} </v-icon>
      <v-icon v-else-if="!hideArrow" :class="['expansion-icon', { 'rotate-180': opened }]">mdi-menu-down</v-icon>
    </div>
    <v-expand-transition>
      <div v-show="opened">
        <div :class="small ? 'pt-2' : 'pt-4'">
          <form-node v-if="!!content" v-bind="content" v-on="$listeners" @open-expandable-box="opened = true" />
          <slot v-else />
        </div>
        <div class="mt-3" @click="toggle">
          <v-icon role="button" class="float-right">mdi-menu-up</v-icon>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import { ComputedOptions } from 'vue'
import { PropsDefinition, Method } from '@/_typedefs'
import { FormNodeProps } from '../FormNode.vue'

/**
 * @typedef {Object} ExpandableBoxNodeProps
 * @property {boolean} [small]
 * @property {boolean} [hideArrow]
 * @property {string} title
 * @property {boolean} [borderHighlight]
 * @property {FormNodeProps} content
 * @property {string} [expandIcon]
 * @property {string} [collapseIcon]
 * @property {boolean} [disabled]
 */

export default {
  name: 'ExpandableBoxNode',
  /** @type {PropsDefinition<ExpandableBoxNodeProps>} */
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    small: {
      type: Boolean,
      default: false,
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    content: {
      type: Object,
      default: null,
    },
    borderHighlight: {
      type: Boolean,
      default: true,
    },
    expandIcon: {
      type: String,
      default: null,
    },
    collapseIcon: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerOpened: false,
    }
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    opened: {
      get() {
        return this.value ?? this.innerOpened
      },
      set(val) {
        this.innerOpened = val
        this.$emit('input', val)
      },
    },
  },
  methods: {
    /** @type {Method<[]>} */
    toggle() {
      this.opened = !this.opened
    },
  },
}
</script>

<style scoped>
.disabled-filter {
  pointer-events: none;
  color: var(--v-neutral-lighten60);
}

.disabled-filter .v-icon {
  color: var(--v-neutral-lighten60);
}

.border-gray {
  border: 1px solid #e6e6e6;
}

.border-blue {
  border: 1px solid #1976d2;
  box-shadow: inset 0 0 0 1px #1976d2;
}

.rotate-180 {
  transform: rotate(180deg);
}
.expansion-icon {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

.fill-background {
  background-color: #f9fafe;
}
</style>
